module.exports = __webpack_public_path__ + "img/20.e5885d1b.jpg";